import * as React from "react"
import Radio from "@mui/material/Radio"
import RadioGroup from "@mui/material/RadioGroup"
import FormControl from "@mui/material/FormControl"
import FormLabel from "@mui/material/FormLabel"
import theme from "src/v2/theme/theme"
import {Box, Typography} from "@mui/material"
import PropTypes from "prop-types"

const GenericRadioButton = ({
                                title,
                                radioButtonItems,
                                defaultRadioValue,
                                onChange,
                            }) => {
    return (
        <FormControl
            sx={{
                display: "flex",
                width: "100%",
            }}
        >
            <FormLabel id="access-level-radio-buttons-group-label">
                <Typography
                    variant="contraHeading"
                    sx={{color: theme.palette.primary.white70}}
                >
                    {title}
                </Typography>
            </FormLabel>
            <RadioGroup
                aria-labelledby="access-level-radio-buttons-group-label"
                defaultValue={defaultRadioValue}
                name="radio-buttons-group"
                onChange={onChange}
                sx={{
                    gap: "7px",
                }}
            >
                {radioButtonItems.map((option) => (
                    <Box
                        key={option.value}
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            width: "fit-content",
                            height: "20px",
                        }}
                    >
                        <Radio
                            disabled={option.disabled}
                            value={option.value}
                            sx={{
                                padding: 0,
                                marginRight: "8px",

                                "&.Mui-checked": {
                                    color: theme.palette.primary.main2,
                                    "& .MuiSvgIcon-root:last-of-type": {
                                        transform: "scale(0.5)",
                                    },
                                },
                                "& .MuiSvgIcon-root": {
                                    width: "20px",
                                    height: "20px",
                                },
                                "& .MuiSvgIcon-root:first-of-type": {
                                    color: theme.palette.white.main,
                                },

                                "&.Mui-disabled": {
                                    color: theme.palette.action.disabled,
                                },

                                "&.Mui-disabled .MuiSvgIcon-root": {
                                    color: theme.palette.action.disabled,
                                },
                            }}
                        />

                        <Typography
                            sx={{
                                color: option.disabled
                                    ? theme.palette.text.disabled
                                    : theme.palette.common.white,
                                lineHeight: "20px",
                                userSelect: "none",
                            }}
                            variant="body2"
                        >
                            {option.label}
                        </Typography>
                    </Box>
                ))}
            </RadioGroup>
        </FormControl>
    )
}

GenericRadioButton.propTypes = {
    title: PropTypes.string.isRequired,
    defaultRadioValue: PropTypes.string.isRequired,
    radioButtonItems: PropTypes.arrayOf(
        PropTypes.shape({
            value: PropTypes.string.isRequired,
            label: PropTypes.string.isRequired,
            disabled: PropTypes.bool,
        })
    ).isRequired,
    onChange: PropTypes.func,
}

export default GenericRadioButton
